// Library imports
import React, { useEffect, useRef, useState } from "react";

// User Component imports
import { VARIABLE_INFO } from "../utils/promptVariables";

/**
 * システムが自動で送る情報の一覧（説明＋値の例）
 * 「プロンプトに書いていないから AI に届いていない」と誤解されないよう、書かなくても送られる情報を案内する
 */
export const AutoSentList = ({ items }) => (
    <div className="ops-auto-list">
        {items.map((name) => {
            const info = VARIABLE_INFO[name];
            return (
                <div key={name} className="ops-auto-item">
                    <span className="ops-auto-label">{info ? info.label : name}</span>
                    {info && info.example && <span className="ops-auto-example">例: {info.example}</span>}
                </div>
            );
        })}
    </div>
);

/**
 * ツールバーの「自動で送る情報」ボタンと吹き出し
 */
const AutoSentInfo = ({ items }) => {
    const [open, setOpen] = useState(false);
    const rootRef = useRef(null);

    // 外側をクリックしたら閉じる
    useEffect(() => {
        if (!open) return undefined;
        const onDown = (e) => {
            if (rootRef.current && !rootRef.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener("mousedown", onDown);
        return () => document.removeEventListener("mousedown", onDown);
    }, [open]);

    return (
        <span className="ops-auto-info" ref={rootRef}>
            <button type="button" className={"ops-auto-info-button" + (open ? " is-active" : "")}
                title="このプロンプトに書かなくても、システムが自動で送る情報を表示します"
                onMouseDown={(e) => e.preventDefault()} onClick={() => setOpen((v) => !v)}>
                <i className="bi bi-info-circle" /><span>自動で送る情報</span>
            </button>
            {open &&
                <div className="ops-auto-info-pop">
                    <div className="ops-auto-info-lead">このプロンプトの後ろに、システムが次の情報を自動で付けて送ります。プロンプトに書く必要はありません。</div>
                    <AutoSentList items={items} />
                </div>
            }
        </span>
    );
};

export default AutoSentInfo;
